import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  MenuItem,
  Select,
} from '@mui/material';

import GroundTruthEnableQuestion from './GroundTruthEnableQuestion';

import {
  sectionAnswerShape, translatableShape, scoresShape, aggregationShape,
} from '../../types';
import GTTable from './GTTable';

const guidRegex = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';

export default class GroundTruthOneOf extends Component {
  specificQuestionRegex = new RegExp(`[0-9]+.[0-9]+.(${this.props.question.uuid}).${guidRegex}`);

  componentDidUpdate(prevProp) {
    // set max score based on new scoreCard update
    const { scores: prevScore } = prevProp;
    if (!prevScore) {
      return;
    }
    const { scores, sectionId, questionId } = this.props;
    const prevMaxScore = prevScore[`maximumScorePerQuestion.${sectionId}.${questionId}`];
    const maxScore = this.getMaximumScore(scores);
    if (prevMaxScore !== maxScore) {
      this.onChangeMinMaxScore('maximumScorePerQuestion', maxScore, sectionId, questionId);
    }
  }

  onChangeMinMaxScore = (name, value, sectionId, questionId) => {
    const fullKey = `${name}.${sectionId}.${questionId}`;
    const { setScore } = this.props;
    setScore(fullKey, value);
  };

  changeScoreHandler = (scoreKey, score) => {
    const { setScore } = this.props;
    setScore(scoreKey, score);
  };

  /**
   * Gets the maximum score only for the messy states object
   * The score are stored state props in format like
   * [sectionIndex].[sampleIndex].[questionUUID].[optionUUID];
   * The special regex above check for this property
   */
  getMaximumScore = (scoreState) => {
    const {
      numSamples,
      question,
    } = this.props;
    let score = 0;
    for (let i = 0; i < numSamples; i += 1) {
      const regexToExec = new RegExp(`[0-9]+.${i}.(${question.uuid}).${guidRegex}`);
      const scoresPerSample = Object.keys(scoreState)
        .filter((key) => regexToExec.test(key))
        .map((key) => scoreState[key]);
      score += Math.max(...scoresPerSample);
    }
    return score;
  };

  renderScoreSelect = (aggregation, sampleIndex, sectionIndex, questionUuid, optionUuid) => {
    const uuid = `${questionUuid}.${optionUuid}`;
    const scoreKey = `${sectionIndex}.${sampleIndex}.${uuid}`;
    const scoreValue = this.props.scores[scoreKey] || 0;

    return (
      <Box display="flex" flexDirection="row" justifyContent="center">
        <Box>
          <Select
            variant="standard"
            id={
              `GroundTruthScore-${sectionIndex}-${sampleIndex}-${uuid}`
            }
            value={scoreValue}
            onChange={(e) => this.changeScoreHandler(scoreKey, e.target.value)}
            disabled={this.props.disabled}
          >
            <MenuItem value={0}>0</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={2}>2</MenuItem>
            <MenuItem value={3}>3</MenuItem>
          </Select>
        </Box>
        <Box>
          (
          {
            aggregation.getOccurrences(
              sampleIndex,
              sectionIndex,
              uuid,
            ) || 0
          }
          )
        </Box>
      </Box>
    );
  };

  render() {
    const { sectionId, questionId, disabled } = this.props;
    return (
      <div
        style={{
          margin: 5,
          marginBottom: 40,
        }}
      >
        <hr />
        <GTTable
          question={this.props.question}
          answers={this.props.answers}
          aggregation={this.props.aggregation}
          section={this.props.section}
          sectionId={this.props.sectionId}
          numSamples={this.props.numSamples}
          renderScoreSelect={this.renderScoreSelect}
          type="OneOf"
        />
        <GroundTruthEnableQuestion
          onChange={this.onChangeMinMaxScore}
          currentMinimumScore={this.props.currentMinimumScore}
          currentMaximumScore={this.props.currentMaximumScore}
          hideMinimumScore={this.props.hideMinimumScore}
          disabled={disabled}
          disableMaximumScore
          sectionId={sectionId}
          questionId={questionId}
        />
      </div>
    );
  }
}

GroundTruthOneOf.defaultProps = {
  sectionId: undefined,
  setScore: () => undefined,
  scores: undefined,
  aggregation: undefined,
  currentMinimumScore: undefined,
  currentMaximumScore: undefined,
  hideMinimumScore: true,
  disabled: false,
};

GroundTruthOneOf.propTypes = {
  numSamples: PropTypes.number.isRequired,
  question: translatableShape.isRequired,
  setScore: PropTypes.func,
  scores: scoresShape,
  answers: sectionAnswerShape.isRequired,
  sectionId: PropTypes.number,
  aggregation: aggregationShape,
  section: PropTypes.shape({ caseNames: PropTypes.arrayOf(PropTypes.string) }).isRequired,
  questionId: PropTypes.number.isRequired,
  currentMinimumScore: PropTypes.number,
  currentMaximumScore: PropTypes.number,
  hideMinimumScore: PropTypes.bool,
  disabled: PropTypes.bool,
};
